import luxuryescapes from './luxuryescapes'

import lebusinesstraveller from './lebusinesstraveller'

const allThemes: { [brand: string]: App.Design.Theme } = {
  luxuryescapes,
  lebusinesstraveller,

}

export default allThemes
